import { CRAWL_DATA_CONDITIONS, type CrawlDataCondition } from "@repo/api-dtos"
import { z } from "zod"

/** Condition a selection reads when the address has none, or an unknown one. */
const DEFAULT_CONDITION: CrawlDataCondition = "NM"

/** Shareable state of the Data page, kept in the address. */
export const crawlDataSearchSchema = z.object({
	game: z.coerce.number().int().positive().optional().catch(undefined),
	rule: z.string().min(1).optional().catch(undefined),
	lang: z.coerce.number().int().positive().optional().catch(undefined),
	cond: z.enum(CRAWL_DATA_CONDITIONS).optional().catch(undefined),
	priced: z.enum(["with", "without"]).optional().catch(undefined),
	product: z.coerce.number().int().positive().optional().catch(undefined),
})
export type CrawlDataSearch = z.infer<typeof crawlDataSearchSchema>

/** One figure of the coverage table: a language and a condition. */
export interface CoverageSelection {
	languageId: number
	condition: CrawlDataCondition
}

/**
 * The selected figure from the address, or null when no language is
 * selected; a missing condition reads as Near Mint.
 */
export function selectionFromSearch(
	search: CrawlDataSearch,
): CoverageSelection | null {
	if (search.lang === undefined) {
		return null
	}
	return {
		languageId: search.lang,
		condition: search.cond ?? DEFAULT_CONDITION,
	}
}

/** The address parameters of a selected figure. */
export function selectionToSearch(
	selection: CoverageSelection,
): Pick<CrawlDataSearch, "lang" | "cond"> {
	return {
		lang: selection.languageId,
		cond: selection.condition,
	}
}
